export default "__VITE_ASSET__CtYZFObb__"